export default [{
  path: '/guest',
  name: 'guest',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/visitor/guest/index')
}]
